import { List, ListItem, ListItemText } from "@mui/material";
import { Grid, Paper, Typography } from "../../../components";
import { FormikProps } from "formik";

type NewBidFormStepThreeProps = {
    formik: FormikProps<{
        company: string;
        miles: string;
        price: string;
        pax: string;
        account_id: string;
        accepts_custom_payment: boolean;
        needs_email_redirect: boolean;
    }>;
}

export const NewBidFormStepThree = ({formik}: NewBidFormStepThreeProps) => {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper variant="outlined">
            <Typography variant="h6" padding={2}>
              Detalhes da Oferta
            </Typography>
            <List>
              <ListItem>
                <ListItemText
                  primary="Programa de Milhas"
                  secondary={formik.values.company || "Não informado"}
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="Total de Milhas para Venda"
                  secondary={`${formik.values.miles?.toLocaleString()} milhas`}
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="Preço por 1.000 Milhas"
                  secondary={
                    formik.values.price
                      ? `R$ ${formik.values.price}`
                      : "Não informado"
                  }
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="Quantidade de CPFs"
                  secondary={formik.values.pax === '0' ? "∞ (Infinito)" :  formik.values.pax}
                />
              </ListItem>
              {formik.values.accepts_custom_payment && (
                <ListItem>
                  <ListItemText
                    primary="Aceita Pagamento à Prazo"
                    secondary="Sim"
                  />
                </ListItem>
              )}
              {formik.values.needs_email_redirect && (
                <ListItem>
                  <ListItemText
                    primary="Redirecionamento de E-mail"
                    secondary="Sim"
                  />
                </ListItem>
              )}
            </List>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};
